import { actions } from './Reducer';

export const setRedirectTrue = () => ({
  type: actions.SET_REDIRECT_TRUE,
  
})

export const setRedirectFalse = () => ({
  type: actions.SET_REDIRECT_FALSE
})